module.exports = __webpack_public_path__ + "download.svg?07912b50bbdf5231c790c2fced8c9195";